import { createContext } from "react";

export const SscIamContext = createContext(undefined);
